import { environment } from 'src/environments/environment';
import { Injectable } from '@angular/core';
import * as forge from 'node-forge';

@Injectable({
    providedIn: 'root'
})
export class RSAEncryptionService {
    // Raw PEM from environment
    private publicKeyPem = environment.rsaPublicKeyPem;

    // Cleaned PEM without extra spaces or line breaks
    private publicKey = forge.pki.publicKeyFromPem(this.cleanPem(this.publicKeyPem));

    encrypt(value: string): string {
        const encrypted = this.publicKey.encrypt(value, 'RSAES-PKCS1-V1_5');
        return forge.util.encode64(encrypted);
    }

    // Remove extra spaces, line breaks, and ensure proper PEM format
    private cleanPem(pem: string): string {
        // Remove BEGIN/END headers and whitespace
        const base64 = pem
            .replace(/-----BEGIN PUBLIC KEY-----/, '')
            .replace(/-----END PUBLIC KEY-----/, '')
            .replace(/[\r\n\s]+/g, '');

        // Re-add proper PEM headers with line breaks every 64 chars
        const formattedBase64 = base64.match(/.{1,64}/g)?.join('\r\n') || '';
        return `-----BEGIN PUBLIC KEY-----\r\n${formattedBase64}\r\n-----END PUBLIC KEY-----`;
    }
}
